<style lang="scss" src='./SensorDetails.scss' scoped></style>
<template src="./SensorDetails.html"></template>

<script>
import GwPassword from '@/components/gwPassword/GwPassword.vue';
import SensorOverview from '@/views/sensors/details/overview/SensorOverview.vue';
import SensorMap from '@/views/sensors/details/map/SensorMap.vue';
import SensorAlerts from '@/views/sensors/details/alerts/SensorAlerts.vue';
import SensorChart from '@/views/sensors/details/chart/SensorChart.vue';
import SensorData from '@/views/sensors/details/data/SensorData.vue';
import SensorForecast from '@/views/sensors/details/forecast/SensorForecast.vue';
import forecastMessages from '@/views/sensors/details/forecast/SensorForecast.i18n';
import SensorLogs from '@/views/sensors/details/logs/SensorLogs.vue';
import SensorCommands from '@/views/sensors/details/commands/SensorCommands.vue';

import { cleanUpSensor, hideSensor, getCourseById, updateSensor, sendSensorOutOfGroundNotification, activateSensor, getSensorForecast } from '@/api/index';
import { mapState, mapActions, mapMutations, } from 'vuex';
import i18n from './../../../i18n';
export default {
  name: 'SensorDetails',
  i18n: { messages: forecastMessages },   // Forecast tab label
  components: {
      GwPassword,
      SensorOverview,
      SensorMap,
      SensorAlerts,
      SensorChart,
      SensorData,
      SensorForecast,
      SensorLogs,
      SensorCommands,
  },
  props: {
    sensor: {
      required: false,
    },
  },
  data() {
    return ({
      enviroment: process.env.VUE_APP_SENTRY_ENV,
      loading: {
        cleaningSensor: false,
        updatingOpsNotes : false,
        activating: false,
      },
      password: null,
      iconRssi: null,
      show_assignation: false,
      ops_notes: null,
      clearData: false,
      forecast: null,
      forecastPending: false,     // next sensor's forecast still loading: keep the tab where it was
      activeTab: 'tab-overview',  // stays on the same tab when another sensor is selected
    });
  },
  computed: {
    ...mapState('sensors', {
      rssiRanges: (state) => state.rssiRanges,
    }),
    // "ok" or "skipped" means the sensor is in a forecast pilot facility; anything else hides the tab.
    forecastEnabled() {
      return !!(this.forecast && ['ok', 'skipped'].includes(this.forecast.status));
    },
    showForecastTab() {
      return this.forecastEnabled || this.forecastPending;
    },
    validCoordinates() {
      if(this.sensor && this.sensor.latitude){
        if(this.G_validateLatLong(this.sensor.latitude, this.sensor.longitude)){
          return true;
        }
      }
      return false;
    }
  },

  watch: {
    sensor : function(newSensor, oldSensor) {
      if (newSensor != oldSensor){
        this.show_assignation = false;
        if (!newSensor || !oldSensor || newSensor.sensor_id !== oldSensor.sensor_id) {
          this.loadForecast();
        }
        if (this.G_canDo(this.consts.Security.Action.HIDE_SENSOR, this.$store.state.user, null)) {
          this.loadCourse();
        }
      }
    }
  },

  methods: {

    async loadForecast() {
      this.forecastPending = this.forecastEnabled;
      this.forecast = null;
      if (!this.sensor) {
        this.forecastPending = false;
        return;
      }
      const sensorId = this.sensor.sensor_id;
      try {
        const res = await getSensorForecast(sensorId);
        if (this.sensor && this.sensor.sensor_id === sensorId) {
          this.forecast = res;
        }
      } catch (e) {
        this.forecast = null;   // endpoint missing or failing: no Forecast tab
      }
      if (this.sensor && this.sensor.sensor_id === sensorId) {
        this.forecastPending = false;
        if (!this.forecastEnabled && this.activeTab === 'tab-forecast') {
          this.activeTab = 'tab-data';   // the new sensor has no forecast: nearest tab
        }
      }
    },

    async provisionTesting() {

      this.loading.activating = true;
      let data = {
        hole_id: null,
        zone_id: null,
        location_code: 'OCA',
        location_desc: 'Other, common area, Testing',
        location_note: 'Testing',
        prongs_depth: 2,
        sensor_depth: 0,
      }

      await activateSensor(this.sensor.sensor_id, data).then((sensor) => {
        this.setSensor(sensor);
        this.updateSensor(sensor);
        this.loading.activating = false;
      });

      this.loading.activating = false;

    },

    notifyOutOfGround() {
      if (this.sensor) {
        sendSensorOutOfGroundNotification(this.sensor.course_id, this.sensor.sensor_id);
      }
    },

    showCourseName(sensor) {
      if (sensor.course_name){
        return sensor.course_name;
      }
      return '';
    },

    getSIMValue(sim) {
      const simValue = this.consts.SIM.find((item) => item.key == sim);
      if (simValue) {
        return simValue.value;
      }
      return '-';
    },

    getNSValue(ns) {
      const mode = this.consts.NET_SWITCHING.find((item) => item.key == ns);
      if (mode) {
        return i18n.t(mode.value);
      }
      return '-';
    },

    getBLEModeValue(bm) {
      const mode = this.consts.BLE_MODE.find((item) => item.key == bm);
      if (mode) {
        return i18n.t(mode.value);
      }
      return '-';
    },

    async loadCourse() {
      if (this.sensor && this.sensor.course_id) {
        
        await getCourseById(this.sensor.course_id).then(response => {
          this.show_assignation = response.show_sensor_assignation;
        });
        
      }else{
        this.show_assignation = false;
      }
    },

    async updateOpsNotes(){
      this.loading.updatingOpsNotes = true;
      const provisionPayload = {'ops_notes': this.ops_notes};
  
      await updateSensor(this.sensor.sensor_id, provisionPayload).then((sensorEdited) => {
        this.sensor.ops_notes = this.ops_notes;
        this.loading.updatingOpsNotes = false;
        this.$bvModal.hide('md-edit-sensor-assignation');
      }).finally(() => {
        this.loading.updatingOpsNotes = false;
      });
    },

    showOpsNotesModal() {
      this.ops_notes = this.sensor.ops_notes;
      this.$bvModal.show('md-edit-sensor-assignation');
    },
    
    async loadRssiIcon() {
      if (this.sensor) {
        
        await this.apiLoadRssiRanges();
        const iconName = this.G_getRssiIcon(this.sensor, this.rssiRanges);
        // eslint-disable-next-line
        this.iconRssi = await require(`@/assets/img/sensor/${iconName}`);
      }
    },

    showFirmwareVersion(sensor) {
      if(sensor.version && 
          sensor.status_id === this.consts.SensorStatus.DEPLOY_PENDING &&
          this.G_canDo(this.consts.Security.Action.SEE_LAST_READING, this.$store.state.user, null)){
        return ' (' + sensor.version + ')';
      }
      return '';
    },
    
    async cleanUpSensor() {
      if (this.password) {
        this.loading.cleaningSensor = true;
          await cleanUpSensor(this.sensor.sensor_id, this.password, this.clearData).then( response => {
            this.cleanUp();
            this.clearData = false;
            if (process.env.VUE_APP_SENTRY_ENV == "production") {
              this.$analytics.logEvent("web_sensor_clean_up");
            }
            this.$bvModal.hide('md-clean-up-sensor');
          }).finally(() => {
            this.loading.cleaningSensor = false;
          });
        
      } else {
        this.$notify({ ignoreDuplicates: true, type: 'warn', text: i18n.t('login.enterYourPassword'), });
      }
    },

    confirmHideSensor (){
      this.G_Alert_v2({ style: this.consts.Style.DANGER, 
        message: this.sensor.hidden 
          ? this.$t('sensors.dyrwToShow') 
          : this.$t('sensors.dyrwToHide') ,
        fnOk: () => {
        hideSensor(this.sensor.sensor_id, !this.sensor.hidden)
        .then((sensor) => {
          this.setSensor(sensor);
          this.updateSensor(sensor);
        });
        }
      });
    },

    isAdminOrOperationsUser() {
      return (this.$store.state.user.user_type.type_id === this.consts.UserType.ADMIN
              || this.$store.state.user.user_type.type_id === this.consts.UserType.OPERATIONS);
    },

    ...mapActions('sensors', ['cleanUp', 'apiLoadRssiRanges']),
    ...mapMutations('sensors', ['updateSensor', 'setSensor']),
  },

  beforeCreate() {},

  created() {},

  mounted() {
    this.show_assignation = false;
    this.loadForecast();
    if (this.G_canDo(this.consts.Security.Action.HIDE_SENSOR, this.$store.state.user, null)) {
      this.loadCourse();
    }
  },

  updated() {
    this.loadRssiIcon();
  },
};
</script>
